import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import Input from '@cashew/input';
import React, { useEffect, useState } from 'react';
import './index.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import SelectComponent from '../../../components/SelectComponent';
import useQuery from '../../../hooks/useQuery';

import {
  getFormattedOrderStatus,
  processOrderStatus,
} from './orders.functions';

const { api } = require('@cashew/utils');

const searchByData = [
  {
    key: 'financePartnerId',
    value: 'Partner ID',
  },
  {
    key: 'name',
    value: 'Partner Name',
  },
  {
    key: 'phoneNumber',
    value: 'Phone number',
  },
  {
    key: 'email',
    value: 'Email',
  },
];

export default ({
  setLoading,
  useSelector,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  history,
  dispatch,
  records,
  setPageNumber,
}: any) => {
  const query = useQuery();
  const { token } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState(query.get('searchId') || '');
  const [searchBy, setSearchBy] = useState<string>(
    query.get('searchBy') || 'financePartnerId'
  );

  const numericInput = /^[0-9]+$/;
  const [reset, setReset] = useState(0);
  const [enterBtn, setEnterBtn] = useState(false);

  console.log({ searchId, searchBy });

  const getOrdersApi = (resetPageNumber = true) => {
    if (resetPageNumber && pageNumber.toString() !== '0') {
      setPageNumber('0');
      return;
    }
    setLoading(true);
    const params: any = {
      pageNumber,
      pageSize,
    };

    if (searchId) {
      params[searchBy] = searchId;
    }

    api
      .get({
        endpoint: 'finance-partner',
        params,
        headers: {
          Authorization: token,
        },
      })
      .then((resp: any) => {
        setLoading(false);
        console.log('resp.data', resp.data);

        setRecords(resp.totalCount);
        const dataList = resp.data.map((item: any) => ({
          ...item,
          status: getFormattedOrderStatus({ item }),
        }));
        setList(dataList);
      })
      .catch((resp: any) => {
        setLoading(false);
        api.errorHandler({
          resp,
          history,
          dispatch,
          callback: () => {
            dispatch({
              type: 'OPEN_TOASTER',
              payload: {
                toasterTitle: 'Fetch orders',
                toasterMessage: 'Error fetching orders',
                toasterType: 'error',
                toasterVisible: true,
              },
            });
          },
        });
      });
  };

  useEffect(() => {
    setPageNumber(0);
  }, [reset]);

  useEffect(() => {
    setLoading(true);
    const timeOut = setTimeout(() => {
      getOrdersApi(false);
    }, 500);
    return () => clearTimeout(timeOut);
  }, [pageNumber, pageSize, enterBtn]);

  useEffect(() => {
    setPageNumber(query.get('pageNumber') || '0');
  }, []);

  useEnterListener(() => setEnterBtn((prev) => !prev));

  const handleSelectChange = (selectedKey: string) => {
    setSearchId('');
    setSearchBy(selectedKey);
  };

  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByData}
              selected={searchBy}
              onSelect={handleSelectChange}
            />
          </div>
          <div className="filter-input">
            <Input
              name="financePartnerId"
              value={searchId}
              type="text"
              maxLength={searchBy === 'financePartnerId' ? 14 : 100}
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'financePartnerId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <Button
              extraClass="btn blue"
              onClick={() => {
                setReset(reset + 1);
                getOrdersApi();
              }}
            >
              Search
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
